// extracted by mini-css-extract-plugin
export var fullGrid = "_3m-3";
export var pdpPreviewContainer = "_3m-1";
export var previewContainer = "_3m-0";
export var togglePreviewContainer = "_3m-2";